// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__39May","footer":"ModalFilter_footer__2NwO8"};